import { appMethod as app } from '@utils/app';
import { convertStyleData } from '@utils/tools';

import './UploadVideoCustomComponent.less';

/**
 * type: 'upload-vieo'
 * 组件：动态表单：添加视频
 */
export default function UploadVideoCustomComponent(props) {
  /**
   * 传入数据
   */
  const data = props.data;                // 组件数据
  const dynamicData = props.dynamicData;  // 动态数据
  const formCompindex = props.formCompindex;    // 动态表单索引
  const form_data = props.form_data || {};      // 动态表单传入数据
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;
  const segment = customFeature.segment;
  const upVideoCount = customFeature.segment;
  /**
   * 样式数据处理
   */
  const styleObj = {
    paddingLeft: '.17rem',
    paddingRight: '.27rem',
    ...convertStyleData(data.style),
  };

  /**
   * 绑定事件
   */

  const uploadFormVideo = (res) => {
    let dataset      = event.currentTarget.dataset;
    let pageInstance = app.getAppCurrentPage();
    let datakey      = dataset.datakey;
    let segment      = dataset.segment;
    let formId       = dataset.formcompid;

    // TODO: 功能暂不支持提醒
    this.noDevelopCompleted();
    return;

    if (!segment) {
      app.showModal({
        content: '该组件未绑定字段 请在电脑编辑页绑定后使用'
      })
      return;
    }
    let hasVideoList = pageInstance.data[formId].form_data ? pageInstance.data[formId].form_data[segment] || [] : [];
    app.chooseVideo({
      success: bar=> {
        app.showLoading({
          title: '视频上传中'
        })
        if(bar == 100) {
          app.hideLoading();
        }
      },
      fail: (err, result)=> {
        if (err.errMsg != 'chooseVideo:fail cancel') {
          app.showModal({
            content: '上传出错，请重新选择上传'
          });
        }
      },
      complete: res=> {
        let newdata = {};
        let video = {
          'id': res['video']['video_id'],
          'fileName': res['video']['video_url'],
          'previewImageUrl': res['video']['image_url'],
          'fileSize': res['video']['file_size'],
          'type': 'video',
          'virtual': '',
          'isFull': false
        };
        hasVideoList.push(video);
        newdata[datakey] = hasVideoList;
        pageInstance.setData(newdata);
      }
    },15)

    // 以下代价不知道需不需要,等确定后再删除
    // let pageInstance = app.getAppCurrentPage();
    // let formcompindex = formCompindex;
    // let segment      = customFeature.segment;
    // let datakey = `eles[${formcompindex}].form_data.${segment}`;

    // let newdata = {};
    // let hasVideoList = form_data[segment] || [];
    // console.log('upload', res)
    // let video = {
    //   'id': res['video']['video_id'],
    //   'fileName': res['video']['video_url'],
    //   'previewImageUrl': res['video']['image_url'],
    //   'fileSize': res['video']['file_size'],
    //   'type': 'video',
    //   'virtual': '',
    //   'isFull': false
    // };
    // newdata[datakey] = [...hasVideoList, video];
    // pageInstance.setData(newdata);
  }

  const noDevelopCompleted = () => {
    app.showModal({
      content: '该组件【添加视频】在webapp端尚在开发中'
    })
  }

  const noBindSegment = () => {
    app.showModal({
      content: '该组件【添加视频】未绑定字段 请在电脑编辑页绑定后使用'
    })
  }

  const deleteUploadVideo = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let formcompindex = formCompindex;
    let datakey = `eles[${formcompindex}].form_data.${customFeature.segment}`;
    app.showModal({
      content: '确定删除该视频？',
      showCancel: true,
      confirm: function () {
        let newdata = {};
        form_data[segment].splice(index, 1);
        newdata[datakey] = form_data[segment];
        pageInstance.setData(newdata);
      }
    })
  }

  const bindplay = (event) => {
    console.log('暂未处理');
    return;
  }

  const bindPlayVideo = (event) => {
    console.log('暂未处理');
    return;
  }

  const bindFullVideo = (event) => {
    console.log('暂未处理');
    return;
  }

  return (
    <div className={`custom-component upload-video ${data.segment_required ? 'must' : ''}`} style={styleObj}>
      {
        form_data[segment] &&
        form_data[segment].map((item, index) => {
          return <div key={item} className="has-upload-video">
            <div className="video-cover">
              {
                !item.isFull &&
                <div className="ico-moon icon-closes delete-img" onClick={() => deleteUploadVideo(index)}></div>
              }
              <div className="controls"
                hidden={item.fileName == item.virtual}
                onClick={bindplay}></div>
              <video controls
                className="video"
                onPlay={bindPlayVideo}></video>
            </div>
          </div>
        })
      }
        {
          (!form_data[segment] || form_data[segment].length < upVideoCount) &&
          <div className="plus-div"
                data-compindex={props.index} 
                data-formcompid={data.formCompid}
                data-segment={data.customFeature.segment}
                data-datakey={`${data.formCompid}.form_data.${data.customFeature.segment}`}
                onClick={uploadFormVideo}
                >
            <span>＋</span>
            <div>添加视频</div>
            {
              segment &&
              <div onClick={noDevelopCompleted}/>
            }
            {
              !segment &&
              <div onClick={noBindSegment}></div>
            }
          </div>
        }
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/upload-video-custom-component/UploadVideoCustomComponent.jsx